










































import { Component, Mixins, Watch, Prop } from "vue-property-decorator";
import { ModelEditableMixin } from "../../system/mixins";
import { Patient } from "../../../domain/patient";

@Component
export default class ReceptionPatientSelector extends Mixins(ModelEditableMixin) {
  @Prop({ default: () => [] as Patient[] })
  options: Patient[];

  @Prop()
  shouldFocusOnInitialize: boolean;

  @Prop()
  patientNo: string;

  data(): any {
    return {
      expand: false,
      selected: null,
    };
  }
  expand: boolean;
  selected: string;

  hideExpandTimer: number;

  $refs!: {
    input: HTMLInputElement;
    ul: HTMLUListElement;
  };

  get shouldShowDropDown(): boolean {
    return this.expand && this.options.length > 0;
  }

  get maxCount(): number {
    return Math.min(this.options.length, 10);
  }

  get selectedListIndex(): number {
    return this.options.findIndex(v => v.id === this.selected);
  }

  mounted() {
    if (this.patientNo) { this.editingSource = this.patientNo; }
    this.updateSelectedWithSource();
    if (this.shouldFocusOnInitialize && !this.disabled) {
      this.$nextTick(() => this.focusInput());
    }
  }

  onInputBlur() {
    this.hideExpand();
  }

  onInputClick() {
    this.toggleExpand();
  }

  onInputKeyDownArrowUp(event: KeyboardEvent) {
    event.stopPropagation();
    event.preventDefault();
  }

  onInputKeyDownArrowDown(event: KeyboardEvent) {
    event.stopPropagation();
    event.preventDefault();
  }

  onInputKeyupUp() {
    this.showExpand();
    this.$nextTick(() => this.focusSelect());
  }

  onInputKeyupDown() {
    this.showExpand();
    this.$nextTick(() => this.focusSelect());
  }

  onInputKeyupEnter() {
    if (this.$refs.input) {
      this.$refs.input.blur();
    }
  }

  onInputKeyupEsc() {
    this.hideExpand();
  }

  onUlFocus() {
    this.showExpand();
  }

  onUlBlur() {
    this.hideExpand();
  }

  onUlKeyDownArrowUp(event: KeyboardEvent) {
    event.stopPropagation();
    event.preventDefault();
    this.selectPreviousOption();
    this.adjustScrollTop();
  }

  onUlKeyDownArrowDown(event: KeyboardEvent) {
    event.stopPropagation();
    event.preventDefault();
    this.selectNextOption();
    this.adjustScrollTop();
  }

  onUlKeyupEnter() {
    this.updateSourceWithSelected();
    this.focusInput();
  }

  onUlKeyupEsc() {
    this.focusInput();
  }

  onListClick(index: number) {
    this.selected = this.options[index].id;
    this.updateSourceWithSelected();
    this.focusInput();
  }

  getListClassName(index: number): string {
    return this.selectedListIndex === index
      ? "list-selected"
      : "list-unselected";
  }

  toString(option: Patient): string {
    return option
      ? (option.id + ")" + option.name)
      : "";
  }

  private selectPreviousOption() {
    const selectedIndex = this.selectedListIndex;
    if (selectedIndex === 0) { return; }
    const previousIndex = selectedIndex - 1;
    if (this.options.length >= previousIndex) {
      this.editingSource = this.options[previousIndex].id;
    }
  }

  private selectNextOption() {
    const selectedIndex = this.selectedListIndex;
    const nextIndex = selectedIndex + 1;
    if (this.options.length === nextIndex) { return; }
    if (this.options.length > nextIndex) {
      this.editingSource = this.options[nextIndex].id;
    }
  }

  private focusSelect() {
    if (this.$refs.ul) {
      this.$refs.ul.focus();
    }
    this.$nextTick(() => this.updateSelectedWithSource());
  }

  private focusInput() {
    if (this.$refs.input) {
      this.$refs.input.focus();
    }
  }

  private showExpand() {
    clearTimeout(this.hideExpandTimer);
    this.expand = true;
  }

  private hideExpand() {
    this.hideExpandTimer = setTimeout(() => this.expand = false);
  }

  private toggleExpand() {
    if (this.expand) {
      this.hideExpand();
    } else {
      this.showExpand();
    }
  }

  private updateSelectedWithSource() {
    if (!!this.editingSource) {
      this.selected = this.editingSource;
    } else if (this.options.length > 0) {
      this.selected = this.options[0].id;
    }
  }

  private updateSourceWithSelected() {
    if (!!this.selected) {
      this.editingSource = this.selected;
    }
  }

  private adjustScrollTop(): void {
    const selectedIndex = this.selectedListIndex;
    if (selectedIndex < 0) { return; }
    if (!this.$refs.ul) { return; }
    const itemClientHeight = this.$refs.ul.scrollHeight / this.options.length;
    // 選択項目を真ん中に表示する（選択項目より小さい値が無ければ１番下に、大きい値が無ければ１番上に表示）
    this.$refs.ul.scrollTop = selectedIndex === (this.options.length - 1) 
      ? this.$refs.ul.scrollHeight - itemClientHeight
      : (itemClientHeight * (selectedIndex - (Math.round(this.maxCount / 2) - 1)));
  }

  @Watch("editingSource")
  onEditingSourceUpdated(newValue: string, oldValue: string) {
    if (this.selected !== newValue) {
      this.updateSelectedWithSource();
    }
  }

  @Watch("expand")
  onExpandUpdated(newValue: boolean, oldValue: boolean) {
    if (!newValue) { return; }
    this.$nextTick(() => {
      this.adjustScrollTop();
    });
  }

  @Watch("options")
  onOptionsUpdated(newValue: Patient[], oldValue: Patient[]) {
    this.$nextTick(() => {
      this.adjustScrollTop();
    });
  }
}
